function capsules(state = {}, action) {
  switch (action.type) {
    case 'FETCH_CAPSULE_DATA_SUCCESS':
      return action.capsules;

    case 'SET_ACTIVE_CAPSULE_ID':
      return {
        ...state,
        ...{ activeSlide: action.activeCapsuleName },
        ...{ activeImage: action.activeCapsuleImage },
        ...{ activeTitle: action.activeCapsuleTitle }
      };

    default:
      return state;
  }
}

export default capsules;
